import React, { Fragment, useEffect, useState } from 'react';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import "./DocumentType.css";
import {  updateDocumentType } from '../../../api/workflow';
import Loader from '../../../components/Loader/Loader';
import { failed, success } from '../../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import {formikAddDocumentType} from "../Constant";
import MultiSelect from '../../../components/InputFields/MultiSelect';
import { useGetStates } from '../../../hooks/useGetStates';


const EditDocumentType = ({ refetch, setShowModal, docData }) => {
    const token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const { states } = useGetStates("US");
    const [statesList, setStateList] = useState([]);
    const [isManageAdmin, setIsManageAdmin] = useState(docData?.isManageAdmin ?? false); // ✅ Initialize from docData

    const dispatch = useDispatch();

    useEffect(() => {
        if (states && states.length > 0) {
            const formattedStates = states.map((obj) => ({
                label: obj.name,
                value: obj.name
            }));
            setStateList(formattedStates);
        }
    }, [states]);

    const formik = useFormik({
        ...formikAddDocumentType,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                const payload = {
                    ...values,
                    isManageAdmin
                };
                res = await updateDocumentType({ values: payload, dispatch, token, docId: docData?._id });
                if (res?.status === "SUCCESS") {
                    setShowModal();
                    success(res?.message);
                    await refetch();
                } else {
                    failed(res?.message);
                }
            } catch (error) {
                failed("An error occurred while updating.");
            } finally {
                setIsLoading(false);
            }
        }
    });

    const handleStates = (applicableStates) => {
        formik.setFieldValue("applicableStates", applicableStates);
    };

    const setEditData = () => {
        formik.setFieldValue("documentTitle", docData?.documentTitle);
        formik.setFieldValue("applicableStates", docData?.applicableStates || []);
        setIsManageAdmin(docData?.isManageAdmin ?? false); // ✅ Ensure state is set correctly
    };

    useEffect(() => {
        setEditData();
    }, []);

    const toggleAdminManage = () => {
        const newAdminManageState = !isManageAdmin;
        setIsManageAdmin(newAdminManageState);

        if (newAdminManageState) {
            // Select all states when checked
            formik.setFieldValue("applicableStates", statesList);
        } else {
            // Clear selection when unchecked
            formik.setFieldValue("applicableStates", []);
        }
    };

    return (
        <Fragment>
            <Modal isOpen={setShowModal} toggle={() => { setShowModal(); }} size="lg" className='user_modal_block add_application_type'>
                <ModalHeader toggle={setShowModal} className="assign_blk">
                    {docData.readOnly ? `View Document Type` : `Edit Document Type`}
                </ModalHeader>
                <Form onSubmit={formik.handleSubmit}>
                    <ModalBody className="assign_modal_body">
                        {isLoading && <Loader />}
                        <div className="add_forms_workflow application_status" style={{ padding: "0px 15px 20px" }}>
                            <div className="first_block mb-0">
                                <Row>
                                    <Col lg={6} className="location_block">
                                        <TextInput
                                            keyField={"documentTitle"}
                                            formik={formik}
                                            readOnly={docData?.readOnly}
                                            label="Document Type Name"
                                            placeholder={"Document Type Name"}
                                            type="text"
                                            value={formik.values.documentTitle}
                                            onChange={(e) => formik.setFieldValue("documentTitle", e.target.value)}
                                        />
                                    </Col>
                                    <Col lg={6} className="location_block">
                                        <MultiSelect
                                            keyField={"applicableStates"}
                                            formik={formik}
                                            label="Applicable States"
                                            disabled={docData?.readOnly || isManageAdmin}
                                            options={statesList}
                                            type="select"
                                            placeholder="Applicable States"
                                            value={formik.values.applicableStates}
                                            onChange={handleStates}
                                        />
                                    </Col>
                                    <Col lg={6} className="location_block mb-3">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                checked={isManageAdmin}
                                                onChange={toggleAdminManage}
                                                disabled={docData?.readOnly}
                                            />
                                            Admin Manage (Select for all states)
                                        </label>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className="p-0 mt-3">
                        {!docData.readOnly && (
                            <div className="d-flex justify-content-center gap-5 mb-4">
                                <button className="save_btn" type="button" onClick={setShowModal}>Close</button>
                                <button className="save_btn second" type="submit">Save</button>
                            </div>
                        )}
                    </ModalFooter>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default EditDocumentType;
